<template>
  <div class="inquiryDetail">
    <el-dialog
      title="问诊单"
      :visible.sync="visible"
      width="540px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="close">
      <div class="inquiryDetail_title" slot="title">
        <el-tabs class="title_tabs" v-model="tabActive">
          <el-tab-pane v-for="tab in list" :key="tab.id" :label="tab.templateName" :name="tab.templateId.toString()"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="content">
        <div v-if="inquiryInfo" class="list">
          <div v-for="(question, questionIndex) in inquiryInfo.questions" :key="question.id" class="list_item">
            <div class="item_title">
              <span v-if="question.required === 1" class="item_title_required">*</span>
              <span class="item_title_text">{{ questionIndex + 1 }}.{{ question.questionsTitle }}</span>
            </div>
            <div v-if="[0, 1, 2].includes(question.questionsType)" class="item_answer_text">{{ question.answerText || '未填写' }}</div>
            <div v-if="[3].includes(question.questionsType) && question.images" class="item_answer_image">
              <div v-if="question.images.length === 0" class="item_answer_text">未填写</div>
              <div class="answer_image_list">
                <el-image v-for="(questionImage, questionImageIndex) in question.images" :key="questionImageIndex" class="answer_image_list_item" :src="questionImage" :preview-src-list="question.images"></el-image>
              </div>
            </div>
            <div v-if="[4].includes(question.questionsType)" class="answer_answer_shortAnswer">
              <div v-if="question.selectAnswerId.imgs.length === 0 && question.selectAnswerId.text === ''" class="item_answer_text">未填写</div>
              <div v-else class="answer_shortAnswer_content">
                <div v-if="question.selectAnswerId.imgs.length > 0" class="answer_shortAnswer_img">
                  <img v-for="(shortAnswerImg, shortAnswerImgIndex) in question.selectAnswerId.imgs" :key="shortAnswerImgIndex" class="answer_shortAnswer_img_item" :src="shortAnswerImg" />
                </div>
                <div v-if="question.selectAnswerId.text" class="answer_shortAnswer_text">{{ question.selectAnswerId.text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getInquiryListApi } from "@/api/webchat"
  export default {
    name: "inquiryDetail",
    data () {
      return {
        visible: false,
        isInquiry: true,
        webChatOrderInfoId: '',
        tabActive: '',
        list: []
      }
    },
    computed: {
      inquiryInfo () {
        const info = this.list.find(v => { return String(v.templateId) === String(this.tabActive) })
        return info
      }
    },
    methods: {
      async getList () {
        const res = await getInquiryListApi({ webChatOrderInfoId: this.webChatOrderInfoId })
        if (res.code === 200) {
          this.list = res.rows.filter(inquiry => {
            return this.isInquiry ? inquiry.templateId !== 29 : inquiry.templateId === 29
          }).map(v => {
            v.questions && v.questions.map(vs=>{
              if ([0, 1].includes(vs.questionsType)) {
                const answerList = vs.selectAnswerId && vs.selectAnswerId.split(',') || []
                vs['answerText'] = vs.answers.filter(answerSelect => {
                  return answerList.includes(String(answerSelect.answerId))
                }).map(answer => { return answer.answerContent }).join(',')
              }
              if ([2].includes(vs.questionsType)) {
                vs['answerText'] = vs.selectAnswerId
              }
							if (vs.questionsType === 3) {
								vs.images = (vs.selectAnswerId && vs.selectAnswerId.split(',')) || []
							}
							if (vs.questionsType === 4) {
								vs.answerType = [null, undefined, ''].includes(vs.answerType) ? [] : vs.answerType.split(',')
								vs.selectAnswerId = [null, undefined, ''].includes(vs.selectAnswerId) ? { imgs: [], text: '' } : JSON.parse(vs.selectAnswerId)
							}
						})
            return v
          }) || []
          if ([null, undefined, ''].includes(this.tabActive)) {
            this.tabActive = this.list[0].templateId.toString()
          }
        }
      },
      open (info) {
        this.webChatOrderInfoId = info.webChatOrderInfoId
        this.isInquiry = info.templateId !== '29'
        this.tabActive = info.templateId
        this.getList()
        this.visible = true
      },
      close () {
        this.webChatOrderInfoId = ''
        this.isInquiry = true
        this.tabActive = ''
        this.list = []
        this.visible = false
      }
    }
  }
</script>

<style lang="less" scoped>
  .inquiryDetail /deep/ .el-dialog__header {
    box-sizing: border-box;
    padding: 0 16px;
    width: 100%;
    height: 48px;
    border-bottom: 1px solid #EBEAEE !important;
  }

  .inquiryDetail /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .inquiryDetail /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
    height: 16px;
  }

  .inquiryDetail /deep/ .el-dialog__body {
    padding: 0;
  }

  .inquiryDetail /deep/ .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #EBEAEE;
  }

  .inquiryDetail_title {
    width: calc(100% - 48px);
    height: 100%;
    background-color: #FFFFFF;
  }

  .title_tabs {
    margin: 0 0 0 0 !important;
    width: 100%;
    height: 100%;
    border: none;
  }

  .title_tabs /deep/ .el-tabs__header {
    margin: 0 0 0 0 !important;
    padding: 0 0 0 0 !important;
  }

  .title_tabs /deep/ .el-tabs__item{
    height: 48px;
    line-height: 48px;
    color: #969799;
  }

  .title_tabs /deep/ .el-tabs__item.is-active{
    color: #323233;
  }

  .content {
    box-sizing: border-box;
    padding: 8px 24px;
    width: 100%;
    height: 600px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .list {
    width: 100%;
    overflow: hidden;
  }

  .list_item {
    box-sizing: border-box;
    padding: 12px 0;
    width: 100%;
    border-bottom: 1px solid #E0E0E0;
    overflow: hidden;
  }

  .item_title {
    width: 100%;
  }

  .item_title_required {
    line-height: 20px;
    font-size: 14px;
    color: #F54A45;
  }

  .item_title_text {
    line-height: 20px;
    font-size: 14px;
    color: #667182;
  }

  .item_answer_text {
    margin: 6px 0 0 0;
    width: 100%;
    line-height: 20px;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    word-wrap: break-word;
    word-break: break-all;
  }

  .item_answer_image {
    width: 100%;
  }

  .answer_image_list {
    margin: 0 -6px 0 0;
    width: 100%;
    overflow: hidden;
  }

  .answer_image_list_item {
    margin: 6px 6px 0 0;
    width: 80px;
    height: 80px;
  }

  .answer_answer_shortAnswer {
    width: 100%;
  }

  .answer_shortAnswer_content {
    margin: 6px 0 0 0;
    width: 100%;
  }

  .answer_shortAnswer_img {
    margin: -6px -6px 0 0;
    width: 100%;
    overflow: hidden;
  }

  .answer_shortAnswer_img_item {
    margin: 6px 6px 0 0;
    width: 80px;
    height: 80px;
  }

  .answer_shortAnswer_text {
    width: 100%;
    line-height: 20px;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    word-wrap: break-word;
    word-break: break-all;
  }

  .answer_shortAnswer_img .answer_shortAnswer_text {
    margin: 6px 0 0 0;
  }
</style>